import React from 'react';

export default function WhyChooseUsSection({ title, description, items, bgColor = "bg-[#FCFAF6]" }) {
  return (
    <section className={`py-12 md:py-24 px-6 lg:px-12 ${bgColor} border-y border-[#E6D5B8]/30`} data-aos="fade-up">
      <div className="container mx-auto max-w-7xl">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-16">
          <div className="w-full lg:w-1/3">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#302621] mb-4 md:mb-6 whitespace-pre-line">{title}</h2>
            <p className="text-sm md:text-base text-[#7A695B] leading-relaxed">{description}</p>
          </div>
          <div className="w-full lg:w-2/3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 lg:gap-10">
              {items.map((feat, idx) => (
                <div key={idx} className="flex gap-4 md:gap-5">
                  <div className="w-10 h-10 md:w-12 md:h-12 shrink-0 rounded-full bg-white border border-[#E6D5B8] flex items-center justify-center text-[#D4AF37] shadow-sm">
                    {React.cloneElement(feat.icon, { className: "w-5 h-5 md:w-6 md:h-6" })}
                  </div>
                  <div>
                    <h4 className="font-bold text-[#302621] text-sm mb-1">{feat.title}</h4>
                    <p className="text-[11px] md:text-xs text-[#7A695B] leading-relaxed">{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
